import { createStateContext } from 'react-use';

interface UserState {
    isLogin: boolean
    token: string
}

const [useUserState, UserStateProvider] = createStateContext<UserState>({
    isLogin: false,
    token: ''
});

export {
    useUserState,
    UserStateProvider
}